import React, { type FC, type PropsWithChildren, useMemo } from 'react';

import { Flex } from '@chakra-ui/react';

export const CVAnalysisLayoutContext = React.createContext<null>(null);

export const CVAnalysisLayout: FC<PropsWithChildren> = ({ children }) => {
  const providerValue = useMemo(() => null, []);

  return (
    <CVAnalysisLayoutContext.Provider value={providerValue}>
      <Flex flex="1" direction="column">
        {children}
      </Flex>
    </CVAnalysisLayoutContext.Provider>
  );
};
